<template>
  <v-navigation-drawer
    v-model="drawer"
    temporary
    location="right"
    width="390"
    class="cart-drawer"
  >
    <div dir="rtl" class="cart-content">
      <div class="cart-header">
        <h2>سلة المشتريات</h2>
        <v-btn icon variant="text" @click="drawer = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>

      <div v-if="!items.length" class="empty-cart">
        <v-icon size="70" color="#916811">mdi-cart-outline</v-icon>
        <h3>السلة فارغة</h3>
        <p>
          ابدأ بإضافة المنتجات التي ترغب بها، ثم تابع خطوات إتمام الطلب بسهولة.
        </p>
      </div>

      <div v-else>
        <div v-for="item in items" :key="item.id" class="cart-item">
          <img :src="item.image" :alt="item.name" class="cart-image" />
          <div class="cart-info">
            <h3>{{ item.name }}</h3>
            <p class="price">{{ item.price }} Dh</p>

            <div class="qty-row">
              <v-btn
                size="x-small"
                variant="outlined"
                @click="decrease(item.id)"
                >-</v-btn
              >
              <span>{{ item.quantity }}</span>
              <v-btn
                size="x-small"
                variant="outlined"
                @click="increase(item.id)"
                >+</v-btn
              >
              <v-btn
                size="x-small"
                color="red"
                variant="text"
                @click="removeFromCart(item.id)"
              >
                حذف
              </v-btn>
            </div>
          </div>
        </div>

        <v-divider class="my-4"></v-divider>

        <div class="summary-line">
          <strong>مجموع الكتب</strong>
          <strong>{{ subtotal }} Dh</strong>
        </div>

        <v-btn class="checkout-btn mt-4" block @click="goToCheckout">
          إتمام الطلب
        </v-btn>
      </div>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapActions, mapState } from "pinia";
import { useCartModule } from "@/stores/cart";

export default {
  inject: ["Emitter"],
  data: () => ({
    drawer: false,
  }),
  computed: {
    ...mapState(useCartModule, ["items", "subtotal"]),
  },
  mounted() {
    this.Emitter.on("openCart", () => {
      this.drawer = true;
    });
  },
  methods: {
    ...mapActions(useCartModule, ["increase", "decrease", "removeFromCart"]),
    goToCheckout() {
      this.drawer = false;
      this.$router.push({ name: "checkout" });
    },
  },
};
</script>

<style scoped>
.cart-drawer {
  font-family: "Noto Kufi Arabic", sans-serif;
}
.cart-content {
  padding: 18px;
}
.cart-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
}
.cart-header h2 {
  font-size: 24px;
  font-weight: 800;
  color: #333;
}
.empty-cart {
  min-height: 330px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  color: #555;
}
.cart-item {
  display: flex;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eee;
}
.cart-image {
  width: 80px;
  height: 105px;
  object-fit: cover;
  border-radius: 12px;
  border: 1px solid #eee;
}
.cart-info {
  flex: 1;
}
.cart-info h3 {
  font-size: 15px;
  line-height: 1.7;
  color: #222;
  margin-bottom: 6px;
}
.price {
  color: #d00000;
  font-weight: 800;
  margin-bottom: 8px;
}
.qty-row {
  display: flex;
  align-items: center;
  gap: 8px;
}
.summary-line {
  display: flex;
  justify-content: space-between;
  font-size: 18px;
}
.checkout-btn {
  background-color: gold;
  color: #111;
  border-radius: 30px;
  font-weight: 800;
  padding: 12px 0;
}
</style>
